import { useTranslation } from "react-i18next";

export default function TaskmapCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.TaskMap");
}
